import { SegmentStatistique } from "./../../../models/SegmentStatistique";
import { ChartDataSets, ChartOptions, ChartType } from "chart.js";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { Portefeuille } from "src/app/fonds-propres/models/Portefeuille";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Label } from "ng2-charts";

@Component({
  selector: "app-segment-apr-details",
  templateUrl: "./segment-apr-details.component.html",
  styleUrls: ["./segment-apr-details.component.scss"],
})
export class SegmentAprDetailsComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: MatTableDataSource<SegmentStatistique>;
  isLoadingResults = true;
  displayedColumns = [
    "codeSegment",
    "NombreLigneCredit",
    "cumulCreanceSaines",
    "cumulCreanceEnSouffrance",
    "cumulProvisions",
    "cumulCreanceNettes",
    "cumulEngagementHorsBilan",
    "cumulApr",
    "cumulFondpropre",
  ];

  barChartLabels: Label[] = [];
  barChartType: ChartType = "bar";
  barChartLegend = true;
  barChartPlugins = [];
  barChartData: ChartDataSets[] = [];

  @Input("segmentStatistiques")
  set data(value: SegmentStatistique[]) {
    this.dataSource = new MatTableDataSource<SegmentStatistique>(value);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.formattedChartDatas(value);
  }
  @Input()
  portefeuille: Portefeuille;

  constructor() {}
  ngOnInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  libelleArry: any[] = [];
  dataNombreArry: any[] = [];
  dataSaineArry: any[] = [];
  dataSouffranceArry: any[] = [];
  dataNettesArry: any[] = [];
  dataEngagementHorsBilanArry: any[] = [];
  dataProvisionsArry: any[] = [];
  dataAprArry: any[] = [];
  dataFpArry: any[] = [];

  formattedChartDatas(data: SegmentStatistique[]) {
    this.libelleArry = [];
    this.dataNombreArry = [];
    this.dataSaineArry = [];
    this.dataSouffranceArry = [];
    this.dataNettesArry = [];
    this.dataEngagementHorsBilanArry = [];
    this.dataProvisionsArry = [];
    this.dataAprArry = [];
    this.dataFpArry = [];
    if (data) {
      data.forEach((element) => {
        this.libelleArry.push(element.codeSegment);
        this.dataNombreArry.push(element.nombreLigneCredit);
        this.dataSaineArry.push(element.cumulCreanceSaines);
        this.dataSouffranceArry.push(element.cumulCreanceEnSouffrance);
        this.dataNettesArry.push(element.cumulCreanceNettes);
        this.dataEngagementHorsBilanArry.push(element.cumulEngagementHorsBilan);
        this.dataProvisionsArry.push(element.cumulProvisions);
        this.dataAprArry.push(element.cumulApr);
        this.dataFpArry.push(element.cumulFondpropre);
      });
    }
    this.barChartLabels = this.libelleArry;
    this.barChartData = [
      {
        label: "Créances saines",
        data: this.dataSaineArry,
        backgroundColor: [
          "#26343b",
          "#26343b",
          "#26343b",
          "#26343b",
          "#26343b",
          "#26343b",
          "#26343b",
          "#26343b",
        ],
        hoverBackgroundColor: [
          "#26343b",
          "#26343b",
          "#26343b",
          "#26343b",
          "#26343b",
          "#26343b",
          "#26343b",
          "#26343b",
        ],
      },
      {
        label: "Créances en souffrance",
        backgroundColor: [
          "#be1a33",
          "#be1a33",
          "#be1a33",
          "#be1a33",
          "#be1a33",
          "#be1a33",
          "#be1a33",
          "#be1a33",
        ],
        hoverBackgroundColor: [
          "#be1a33",
          "#be1a33",
          "#be1a33",
          "#be1a33",
          "#be1a33",
          "#be1a33",
          "#be1a33",
          "#be1a33",
        ],
        data: this.dataSouffranceArry,
      },
      {
        label: "Provisions",
        backgroundColor: [
          "#046cd0",
          "#046cd0",
          "#046cd0",
          "#046cd0",
          "#046cd0",
          "#046cd0",
          "#046cd0",
          "#046cd0",
        ],
        hoverBackgroundColor: [
          "#046cd0",
          "#046cd0",
          "#046cd0",
          "#046cd0",
          "#046cd0",
          "#046cd0",
          "#046cd0",
          "#046cd0",
        ],
        data: this.dataProvisionsArry,
      },
      {
        label: "Créances nettes",
        backgroundColor: [
          "#00b786",
          "#00b786",
          "#00b786",
          "#00b786",
          "#00b786",
          "#00b786",
          "#00b786",
          "#00b786",
        ],
        hoverBackgroundColor: [
          "#00b786",
          "#00b786",
          "#00b786",
          "#00b786",
          "#00b786",
          "#00b786",
          "#00b786",
          "#00b786",
        ],
        data: this.dataNettesArry,
      },
      {
        label: "Engagements hors-bilan",
        backgroundColor: [
          "#f86929",
          "#f86929",
          "#f86929",
          "#f86929",
          "#f86929",
          "#f86929",
          "#f86929",
          "#f86929",
        ],
        hoverBackgroundColor: [
          "#f86929",
          "#f86929",
          "#f86929",
          "#f86929",
          "#f86929",
          "#f86929",
          "#f86929",
          "#f86929",
        ],
        data: this.dataEngagementHorsBilanArry,
      },
    ];
  }

  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      xAxes: [{}],
      yAxes: [
        {
          ticks: {
            callback: function (value, index, values) {
              return Intl.NumberFormat("fr-FR").format(Number(value));
            },
          },
        },
      ],
    },
    tooltips: {
      enabled: true,
      callbacks: {
        label: function (tooltipItem, data) {
          //let label = data.labels[tooltipItem.index];
          let value =
            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          let legend = data.datasets[tooltipItem.datasetIndex].label;
          return (
            " " +
            legend +
            ": " +
            Intl.NumberFormat("fr-FR", {
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            }).format(Number(value))
          );
        },
      },
    },
    plugins: {
      datalabels: {
        anchor: "end",
        align: "end",
      },
    },
  };
}
